<template>
    <div v-if="!passwordSent">
        <form action="" id="forgotten-password-form" @submit.prevent="submitForgottenPassword" novalidate>
            <div class="as-logo-container"><img :src="logoRougeNoTextSrc" alt="Logo des As de l'info"></div>

            <div class="form-intro" v-html=" copydeck?.forgottenPasswordIntro?.fr ?? '' "></div>

            <input type="hidden"
                   id="recaptcha_token"
                   name="recaptcha_token"
                   v-model="forgottenPasswordFormData.recaptcha_token"/>

            <div class="input-group">
                <label for="login-email">Courriel <i class="form-required-field-star">*</i></label>
                <input name="login-email"
                       id="login-email"
                       type="text"
                       autocomplete="email"
                       v-model="forgottenPasswordFormData.email"
                       @keydown="clearSingleFieldErrors('email')"
                       ref="forgotPasswordEmail"
                       required>
                <form-error
                    v-if="formErrors.email"
                    :error="formErrors.email"
                ></form-error>

            </div>


            <div class="centered">
                <button type="submit" class="button btn-submit btn-submit-login" ref="btnForgotPasswordSubmit"
                        :disabled="forgottenPasswordFormData.username === ''  ">
                    <span class="ajax-loader white centered"></span> <span
                    v-html=" copydeck?.btnForgotPassword?.fr ?? '' "></span>
                </button>
            </div>
        </form>

        <div class="register-link-container">

            <button type="button" class="text-link link-login link-mode-toggle"
                    @click="changeMode('login')">{{ copydeck?.btnLoginMode?.fr ?? '' }}
            </button>
            <br class="line-break">
            <button type="button" class="text-link link-register link-mode-toggle"
                    @click="changeMode('register')">{{ copydeck?.btnRegisterToggle?.fr ?? '' }}
            </button>
        </div>
    </div>

    <div class="password-sent" v-if="passwordSent" v-html="  copydeck?.passwordSent?.fr ?? '' "></div>
</template>

<script setup>
// Vue
import { ref, reactive, computed } from 'vue';
import { useStore }                from 'vuex';
import axios                       from 'axios';

// store
let store    = useStore();
let copydeck = computed( () => store.state.copydeck );

const logoRougeNoTextSrc = new URL( '../../../../images/logo-rouge-no-text.svg', import.meta.url ).href;

let formErrors = computed( () => store.state.formErrors );

// composables
import { changeMode, clearSingleFieldErrors } from '../composables';


// components
import FormError from './FormError.vue';

let btnForgotPasswordSubmit = ref( null );

let passwordSent        = ref( false );
let forgotPasswordEmail = ref( null );

const forgottenPasswordFormData = reactive( {
    email           : '',
    recaptcha_token : '',
} );


async function submitForgottenPassword ()
{

    btnForgotPasswordSubmit.value.disabled = true;
    btnForgotPasswordSubmit.value.classList.add( 'ajaxing' );


    let response = await axios.post( "/endpoints/user/forgot-password", forgottenPasswordFormData );

    passwordSent.value = true;

    btnForgotPasswordSubmit.value.disabled = false;
    btnForgotPasswordSubmit.value.classList.remove( 'ajaxing' );


}
</script>

<style scoped>

</style>
